import React from 'react';
import ReactDOM from 'react-dom';

class Loader extends React.Component {

    render() { 
        return (
            <div id="loader">
                <div className="spinner-border text-danger" role="status"></div>
            </div>
        );
    }
}
      
export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js